module.exports = __webpack_public_path__ + "img/slotmachine_free_fg.f5fd332b.png";